import * as formik from 'formik';
import { useState } from 'react';
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { toast } from 'react-toastify';
import { Menu, Table } from "../../components";
import useGetFetch from '../../hooks/useGetTable';
import useTable from '../../hooks/useTableControllers';
import { InvoiceIcetexReport } from '../../interfaces/invoiceIcetex.interface';
import { PaginationType } from '../../interfaces/response.interface';
import { FilterModel, TableModel } from '../../interfaces/table.interface';
import { createFilterModel, defaultPagination, getColumns, onFetchGetPdfInvoiceIcetexData, onFetchInvoiceIcetexData } from './checkInvoiceIcetex.const';
import { checkInvoiceIcetexSchema, checkInvoiceIcetexType } from './checkInvoiceIcetex.schema';

const CheckInvoiceIcetex: React.FC = () => {


    const { Formik } = formik;
    const [filterModel, setFilterModel] = useState<FilterModel<InvoiceIcetexReport>[]>([]);

    const {
        loading,
        error,
        data: process,
        handleData,
    } = useGetFetch<PaginationType<InvoiceIcetexReport>, TableModel<InvoiceIcetexReport>>(onFetchInvoiceIcetexData, {
        paginationModel: defaultPagination,
        filterModel,
    });

    const tableControllers = useTable<InvoiceIcetexReport>(
        {
            filterModel,
            paginationModel: process
                ? { ...defaultPagination }
                : defaultPagination,
        },
        handleData,
    );

    const onSubmit = async (form: checkInvoiceIcetexType) => {
        const { setCurrentPage } = tableControllers;
        let formData: FormData = new FormData();

        const formFields = ['applicantId', 'email', 'ticket', 'startDate', 'endDate'];

        formFields.forEach(field => {
            if (form[field]) {
                formData.append(field, form[field]);
            }
        });

        const filterModel = createFilterModel({
            applicantId: form.applicantId,
            email: form.email,
            ticket: form.ticket,
            dateRange: {
                startDate: form.startDate,
                endDate: form.endDate
            }
        });

        setCurrentPage(1);
        setFilterModel(filterModel as FilterModel<InvoiceIcetexReport>[]);
    }

    const onDetail = async (id: number, applicantId: string): Promise<void> => {
        try {
            toast.info('Generando el pdf del usuario ' + applicantId);
            const response = await onFetchGetPdfInvoiceIcetexData(id);
            if (response.status === 200) {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `invoice-${applicantId}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                toast.success('El pdf se genero exitosamente');
            } else {
                toast.error('No se pudo descargar el pdf notificar con soporte');
            }
        } catch (error) {
            toast.error('No se pudo descargar el pdf notificar con soporte');
        }
    }

    return (
        <div>
            <Menu />
            <div className="d-flex justify-content-center mt-3">
                <h3>Consultar facturas</h3>
            </div>
            <Container style={{ minWidth: '1000px' }}>
                <Formik
                    validationSchema={checkInvoiceIcetexSchema}
                    onSubmit={onSubmit}
                    initialValues={{
                        applicantId: '',
                        email: '',
                        startDate: '',
                        endDate: '',
                        ticket: '',
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors, isValid, dirty }) => (
                        <formik.Form noValidate onSubmit={handleSubmit}>
                            <Row style={{ paddingTop: '15px' }}>
                                <Col style={{ paddingBottom: '55px' }}>
                                    <Form.Group controlId="formFile" className="mb-1">
                                        <Form.Label style={{ whiteSpace: 'nowrap' }}>Documento ID</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name='applicantId'
                                            onChange={handleChange}
                                            isInvalid={!!errors.applicantId}
                                        />
                                        <Form.Control.Feedback type="invalid" style={{ minHeight: '1rem' }}>
                                            {errors.applicantId}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col style={{ paddingBottom: '55px' }}>
                                    <Form.Group className="mb-1">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name='email'
                                            onChange={handleChange}
                                            value={values.email}
                                            isInvalid={!!errors.email}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.email}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col style={{ paddingBottom: '5px' }}>
                                    <Form.Group className="mb-1">
                                        <Form.Label>Ticket</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name='ticket'
                                            onChange={handleChange}
                                            value={values.ticket}
                                            isInvalid={!!errors.ticket}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.ticket}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col style={{ paddingBottom: '5px' }}>
                                    <Form.Group className="mb-1">
                                        <Form.Label>Fecha de corte inicio</Form.Label>
                                        <Form.Control
                                            required
                                            type="date"
                                            name='startDate'
                                            onChange={handleChange}
                                            value={values.startDate}
                                            isInvalid={!!errors.startDate}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.startDate}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col style={{ paddingBottom: '5px' }}>
                                    <Form.Group className="mb-1">
                                        <Form.Label>Fecha de corte final</Form.Label>
                                        <Form.Control
                                            required
                                            type="date"
                                            name='endDate'
                                            onChange={handleChange}
                                            value={values.endDate}
                                            isInvalid={!!errors.endDate}
                                        />
                                        <div style={{ minHeight: '3rem', color: '#dc3545' }}>
                                            {errors.endDate}
                                        </div>
                                    </Form.Group>
                                </Col>
                                {/*TODO: cuando sale mensaje de error se pierde la centrada vertical del botón */}
                                <Col style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Button
                                        type="submit"
                                        disabled={!isValid || loading}
                                        style={{ position: 'absolute', top: '32px' }} >
                                        {loading ? 'Consultando...' : 'Consultar'}
                                    </Button>
                                </Col>
                            </Row>
                        </formik.Form>
                    )}
                </Formik>
                <Table<InvoiceIcetexReport>
                    {...tableControllers}
                    columns={getColumns(onDetail)}
                    rows={process?.result || []}
                    rowsPerPage={defaultPagination.limit}
                    totalPages={process?.totalPages || 0}
                    totalRows={process?.count}
                    downloadDisabled={() => filterModel.length === 0}
                    loading={loading}
                />
            </Container>
        </div>
    )

}
export default CheckInvoiceIcetex